import { useTermsGuard } from '@/pages/TermsAgreement/hooks/useTermsGuard';
import { setAuthChecked } from '@store/auth/authSlice';
import { verifySession } from '@store/auth/thunks';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { isDef } from '@utils/def';
import React, { lazy, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import HomeRoute from './components/HomeRoute';
import { routes } from './components/Routes';
import SafeRoute from './components/SafeRoute';

const Login = lazy(() => import('@pages/Login'));
const SsoLogin = lazy(() => import('@pages/SsoLogin'));

const PMCARoutes: React.FC = () => {
  const dispatch = useAppDispatch();
  const { authChecked, permissions } = useAppSelector((state) => state.auth);

  useTermsGuard();

  useEffect(() => {
    if (!authChecked) {
      dispatch(verifySession());
      dispatch(setAuthChecked(true));
    }
  }, [authChecked, dispatch]);

  return (
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/login" element={<Login />} />
      {/*<Route path="/reset-password" element={<ResetPassword />} />*/}
      <Route path="/sso-login/:idProvider" element={<SsoLogin />} />
      {Object.entries(routes)
        .filter(([_, settings]) => {
          if (!isDef(settings.permission) && !isDef(settings.onOfPermission)) {
            return true;
          }
          if (!permissions.length) {
            return false;
          }
          if (isDef(settings.onOfPermission)) {
            return settings.onOfPermission.some((permission) =>
              permissions?.includes(permission),
            );
          }
          if (isDef(settings.permission)) {
            return permissions.includes(settings.permission);
          }
        })
        .map(([routeName, settings]) => (
          <Route
            key={routeName}
            path={settings.url}
            element={
              settings.componentRoute ? (
                <settings.componentRoute>
                  <settings.component />
                </settings.componentRoute>
              ) : (
                <SafeRoute isProtected>
                  <settings.component />
                </SafeRoute>
              )
            }
          />
        ))}
    </Routes>
  );
};

export default PMCARoutes;
